const brItemPrice = {
  itemPrice: {
    label: {
      name: 'Nome',
      selectItem: 'Selecione um item',
      selectedItem: 'Item selecionado',
      in: 'em',
      basePrice: 'Preço base',
      comboPrice: 'Preço combo',
      comboEnabler: 'Habilitar combo?',
    },

    hints: {
      delete: 'Deseja mesmo apagar o preço deste item para esta tabela?',
      basePriceIsRequired: 'Preço base é obrigatório',
    },

    action: {
      addPrice: 'Adicionar preço',
      editPrice: 'Editar preço',
      comboIsEnabled: 'Combo habilitado',
      comboIsNotEnabled: 'Combo desabilidato',
      delete: 'Apagar preço do item',
      cancel: 'Cancelar',
    },

    messages: {
      successfullyCreated: 'Preço do item criado com sucesso',
      successfullyUpdated: 'Preço do item atualizado com sucesso',
      successfullyDeleted: 'Preço do item removido com sucesso',
    },
  },
}

export default brItemPrice
